import { getParamCaseInsensitive } from "../utility/helpers/windowHelper";
import { IDENTITY_CONFIG, METADATA_OIDC } from "./authConst";
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

export default class AuthService {
    UserManager: any;
    static instance: any;
    user: any;

    constructor() {
        if (AuthService.instance) {
            return AuthService.instance;
        }

        // initialize UserManager instance
        this.user = null;
        AuthService.instance = this;

        const queryParams = new URLSearchParams(window.location.search);
        const donate = getParamCaseInsensitive(queryParams, "donate");

        var acrValues: string = "";
        if (donate !== null && donate !== undefined){
            acrValues = `donate=${donate}`;

            const organizationid = getParamCaseInsensitive(queryParams, "organizationid");
            if (organizationid) {
                acrValues = acrValues + `&organizationid=${organizationid}`;
            }

            const campaignid = getParamCaseInsensitive(queryParams, "campaignid");
            if (campaignid) {
                acrValues = acrValues + `&campaignId=${campaignid}`;
            }
        }

        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            acr_values: acrValues,
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
            metadata: {
                ...METADATA_OIDC,
            },
        });

        this.UserManager.events.addUserLoaded((user: any) => {
            if (window.location.href.indexOf("signin-oidc") !== -1) {
                this.navigateToScreen();
            }
        });
        this.UserManager.events.addSilentRenewError((e: any) => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.logout();
        });
    }

    static getInstance() {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }

    signinRedirectCallback = () => {
        try {
            this.UserManager.signinRedirectCallback().then(
                (user: any) => {
          window.history.replaceState(
            {},
                        window.document.title,
                        window.location.origin
                    );
                },
                (err: any) => {
                    console.error(err);
                }
            );
        } catch (err) {
            console.error(err);
        }
    };

    getUser = async () => {
        const user = await this.UserManager.getUser();
        if (!user) {
            console.log("not logged in: ");
            return await this.UserManager.signinRedirectCallback();
        }
        return user;
    };

    parseJwt = (token: any) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };

    signinRedirect = () => {
    localStorage.setItem("redirectUri", window.location?.pathname);
    this.UserManager.signinRedirect({});
    };

    navigateToScreen = () => {
        window.location.replace("/");
    };

    isAuthenticated = () => {
    const item: string | null = sessionStorage.getItem(
      `oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`
    );
        const oidcStorage = item != null ? JSON.parse(item) : null;

        return !!oidcStorage && !!oidcStorage.access_token;
    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user: any) => {
                console.log("signed in", user);
            })
            .catch((err: any) => {
                console.log(err);
            });
    };
    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.removeUser();
        this.UserManager.signoutRedirect();
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            window.location.replace("/");
        });
        this.UserManager.clearStaleState();
    };
}
